
import React, { Component } from 'react';
import StickyFixedHeader from "../../general/stickyHeader/stickyFixedHeader";
import { Button, Input} from 'reactstrap';
import { IoIosCloseCircleOutline } from "react-icons/io"
import Switch from "react-switch";
import { BsCashStack } from "react-icons/bs"
import { BsCreditCard2Back } from "react-icons/bs"
import { AiOutlinePlusSquare } from "react-icons/ai";
import { AiOutlineMinusSquare } from "react-icons/ai";
import ScaleLoader from "react-spinners/ScaleLoader";
import { BottomSheet } from 'react-spring-bottom-sheet'
import PaymentComponent from "../payments/paymentComponent";

const stateManager = require('../../../../utils/state/stateManager');
const stringUtil = require('../../../../utils/string/stringUtil');
const formatter = require('../../../../utils/formatter/formatter');
const basketUtil = require('../../../../utils/basket/basketUtil');
const userUtil = require('../../../../utils/user/userUtil');
const basketApiProxy = require('../../../../utils/api/basketApiProxy.js');
const viewUtil = require('../../../../utils/view/viewUtil');
const previousOrdersUtil = require('../../../../utils/previousOrders/previousOrdersUtil');
const fatalErrorAction = require('../../../../utils/state/actions/error/fatalErrorAction');
const currentComponentAction = require('../../../../utils/state/actions/component/currentComponentAction');
const localizationUtils = require('../../../../utils/localization/localizationUtils');
const constants = require('../../../../utils/domain/constants');

class Basket extends Component 
{
    constructor(props)
    {
        super(props);
        
        this.state = {};
        this.state.haltFurtherEnrichmentRequests = false;

        this.state.processingMessage = null;
        this.state.showCreditCardPaymentComponent = false; 
   }
    
    render()
    {
        var state = stateManager.getStore().getState();
        if (basketUtil.isBasketEmpty())
        {
            return <div>
                        {this.renderHeader()}
                        <div style={{marginTop:'50px', textAlign:'center'}}>
                            Your <b>{state.basket.order.dispatchType}</b> basket is empty
                        </div>
                    </div>
        }

        this.enrichBasket();

        return <div>
                    {this.renderHeader()}

                    <div style={{marginTop:'10px', marginLeft:'15px', marginRight:'15px'}}>
                        <div style={{marginTop:'20px'}}>
                            <h4 style={{fontWeight:'bold', marginBottom:'0px'}}>Your {state.basket.order.dispatchType} Basket</h4>
                        </div>

                        <div style={{marginTop:'30px'}}>
                            {this.renderDispatchTimesInMinutes()}
                        </div>

                        <hr style={{marginTop:'5px', marginBottom:'0px'}}/> 
                        
                        <div style={{marginTop:'30px'}}>
                            {this.renderAddCutleryComponent()}
                        </div>

                        <hr style={{marginTop:'5px', marginBottom:'0px'}}/> 
                        
                        <div>
                            {this.renderOrders()}
                        </div>

                        <div>
                            {this.renderPriceWidget()}
                        </div>

                        <div>
                            {this.renderVoucherCode()}
                        </div>

                        <div>
                            {this.renderKitchenNodesWidget()}
                        </div>

                        <div>
                            {
                                !stringUtil.areStringSame(stateManager.getStore().getState().currentMode, constants.applicationMode.overPhonePayment) ? this.renderPaymentMethod(): null
                            }
                        </div>

                        <div style={{marginTop:'30px', marginBottom:'50px', textAlign:'center'}}>
                            {this.renderProceedToPaymentButton()}
                            {
                                stateManager.getStore().getState().franchisor.displayResellerBranding
                                ? <div className='smallText' style={{color:`var(--muted-text-color)`, textAlign: 'center', paddingTop: '15px', paddingBottom: '5px'}}>Powered by Flipdish</div>
                                : null
                            }
                        </div>
                    </div>
                    {
                        this.renderCreditCardPaymentComponent()
                    }
                    {
                        this.renderProcessingMessage()
                    }

                </div>
    }

    renderHeader()
    {
        var state = stateManager.getStore().getState();

        return <div>
                    <StickyFixedHeader>
                        <div className='AppBar'>
                            <table style={{width:'100%'}}>
                                <tr>
                                    <td style={{width:'99%'}}>
                                        <div  style={{paddingLeft:'10px', paddingRight:'10px',paddingTop:'5px'}}>
                                            <div>{state.property.name}</div>
                                            <div className='smallText'>{state.property.address}</div>
                                        </div>

                                    </td>
                                    <td style={{whiteSpace:'nowrap'}}>
                                        <div style={{marginLeft:'10px', marginRight:'5px', fontSize:`var(--button-close-size)`, color:`var(--button-close-color)`}}
                                             onClick={()=>
                                                    {
                                                        const store = stateManager.getStore();
                                                        const state = store.getState()
                                                    
                                                        if(basketUtil.isCurrentBasketForPaymentOverPhone())
                                                            state.basket.doRequireEnrichment = true;

                                                        store.dispatch(currentComponentAction.createAction("store"));
                                                    }}>
                                            <IoIosCloseCircleOutline/>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            
                    
                            <hr style={{marginTop:'5px', marginBottom:'0px'}}/> 
                        </div>
                    </StickyFixedHeader> 
                </div>
    }

    renderDispatchTimesInMinutes()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;
        var dispatchType = basket.order.dispatchType;

        var caption = `Prepare My Order`;
        var subCaption = `We will start preparing your order for ${dispatchType} immediatley`
        
        if (!stringUtil.isStringNullOrEmpty(basket.dispatchTimeInMinutes))
        {
            subCaption = `We will start preparing your order for ${dispatchType} in ${basket.dispatchTimeInMinutes} minutes`;
        }

        var timingsHeader = "Now";
        if (!stringUtil.isStringNullOrEmpty(basket.dispatchTimeInMinutes))
            timingsHeader = `${basket.dispatchTimeInMinutes} minutes`

        


        return <table style={{width:'100%'}}>
                    <tr>
                        <td style={{width:'99%'}}>
                            <div style={{fontWeight:'bold'}}>{caption}</div>
                        </td>
                        <td style={{whiteSpace:'nowrap', verticalAlign:'top'}}>
                            <table style={{width:'100%'}}>
                                <tr>
                                    <td>
                                        <div style={{marginRight:'2px'}}>
                                            <AiOutlinePlusSquare style={{fontSize: `var(--button-change-quantity-size)`, marginRight:'5px'}}
                                                                            onClick={()=>
                                                                            {
                                                                                if (stringUtil.isStringNullOrEmpty(basket.dispatchTimeInMinutes))
                                                                                {
                                                                                    basket.dispatchTimeInMinutes = 15;
                                                                                    this.setState({});
                                                                                    return;
                                                                                }

                                                                                if (basket.dispatchTimeInMinutes >= 180)
                                                                                    return;

                                                                                basket.dispatchTimeInMinutes = basket.dispatchTimeInMinutes + 5;
                                                                                this.setState({});
                                                                                return;
                                                                            }}/>
                                        </div>
                                    </td>
                                    <td>
                                        <div style={{userSelect:'none'}}>{timingsHeader}</div>
                                    </td>
                                    <td>

                                    <div style={{marginLeft:'7px'}}>
                                        <AiOutlineMinusSquare style={{fontSize: `var(--button-change-quantity-size)`}}
                                                                            onClick={()=>
                                                                                {
                                                                                    if (stringUtil.isStringNullOrEmpty(basket.dispatchTimeInMinutes))
                                                                                        return;
                                                                              
                                                                                    if (basket.dispatchTimeInMinutes == 15)
                                                                                    {
                                                                                        basket.dispatchTimeInMinutes = "";
                                                                                        this.setState({});
                                                                                        return;
                                                                                    }

                                                                                    basket.dispatchTimeInMinutes = basket.dispatchTimeInMinutes - 5;
                                                                                    this.setState({});
                                                                                    return;
                                                                                }}/>
                                    </div>

                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="2">
                            <div className='smallText' style={{color:`var(--muted-text-color)`}}>{subCaption}</div>
                        </td>
                    </tr>
               </table>
    }

    renderAddCutleryComponent()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;

        return <table style={{width:'100%'}}>
                    <tr>
                        <td style={{width:'99%'}}>
                            <div style={{fontWeight:'bold'}}>Add cutlery</div>
                            <div className='smallText' style={{color:`var(--muted-text-color)`}}>Help us reduce plastic wastage - only request cutlery when you need it.</div>
                        </td>
                        <td style={{whiteSpace:'nowrap'}}>
                            <Switch className="react-switch" 
                                    checked={basket.doRequireCutleries} 
                                    onChange={(checked)=>
                                        {
                                            basket.doRequireCutleries = checked;
                                            this.setState({});
                                        }}/>
                        </td>
                    </tr>
                </table>
    }

    renderOrders()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;
        
        var components = [];

        for (var index = 0; index < basket.order.saleItems.length; index++)
        {
            components.push(this.renderItem(basket.order.saleItems[index]));
        }
        
        return <div style={{marginTop:'30px'}}>
                    {components}
                    <hr style={{marginTop:'10px', marginBottom:'0px'}}/> 
               </div>
    }

    renderItem(saleItem)
    {
        var components = [];

        components.push(
                            <tr>
                                <td style={{width:'5%', whiteSpace:'nowrap', verticalAlign:'middle', textAlign:'left'}}>
                                    {saleItem.quantity}
                                </td>
                                <td style={{fontWeight:'bold', verticalAlign:'middle', textAlign:'left'}}>
                                    <div style={{marginLeft:'8px'}}>{saleItem.caption}</div>
                                </td>
                                <td style={{width:'10%', textAlign:'right'}}>
                                    <div style={{marginLeft:'5px'}}>
                                        <AiOutlinePlusSquare style={{fontSize: `var(--button-change-quantity-size)`, marginRight:'5px'}}
                                                                        onClick={()=>
                                                                        {
                                                                            this.changeQuantity(saleItem, 1);
                                                                        }}/>
                                    </div>
                                </td>
                                <td style={{width:'10%', textAlign:'right'}}>
                                    <div style={{marginRight:'5px'}}>
                                        <AiOutlineMinusSquare style={{fontSize: `var(--button-change-quantity-size)`}}
                                                                            onClick={()=>
                                                                                {
                                                                                    this.changeQuantity(saleItem, -1);
                                                                                }}/>
                                    </div>
                                </td>
                                <td style={{width:'20%', whiteSpace:'nowrap', verticalAlign:'middle', textAlign:'right'}}>
                                    {formatter.convertToCurrencyFormat(saleItem.quantity * saleItem.unitPrice)}
                                </td>
                            </tr>
                        )
        this.renderSubItems(saleItem, components, 8);
        

        components = <table style={{width:'100%', tableLayout:'fixed'}}>{components}</table>
        return <div style={{marginBottom:'10px'}}>{components}</div>;
    }

    renderSubItems(saleItem, components, margin)
    {
        saleItem.saleItems.forEach(subSaleItem =>
            {
                var priceComponent = <div>&nbsp;</div>
                if (subSaleItem.unitPrice > 0)
                {
                    priceComponent = formatter.convertToCurrencyFormat(subSaleItem.quantity * subSaleItem.unitPrice);
                }
                components.push(
                                    <tr>
                                        <td style={{whiteSpace:'nowrap', verticalAlign:'middle', textAlign:'left'}}>
                                            &nbsp;
                                        </td>
                                        <td style={{verticalAlign:'middle', textAlign:'left'}}>
                                            <div style={{marginLeft:`${margin}px`}}>{stringUtil.trimString(subSaleItem.caption)}</div>
                                        </td>
                                        <td>
                                            &nbsp;
                                        </td>
                                        <td>
                                            &nbsp;
                                        </td>
                                        <td style={{whiteSpace:'nowrap', verticalAlign:'middle', textAlign:'right'}}>
                                            {priceComponent}
                                        </td>
                                    </tr>
                                );
                this.renderSubItems(subSaleItem, components, margin+5);
            })
    }

    renderVoucherCode()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;
        return <div style={{marginTop:'30px'}}>
                <div style={{fontWeight:'bold'}}>Do you have a voucher code</div>
                    <Input
                            type="text" placeholder="Please enter voucher or discount code" 
                            value={basket.voucherCode ?? ""}
                            onChange={(event)=>
                                {
                                    basket.voucherCode = stringUtil.trimString(event.target.value);
                                    this.setState({});
                                }}
                            onBlur={()=>
                            {
                                basketUtil.markBasketForEnrichment();
                                this.state.haltFurtherEnrichmentRequests = false;
                                this.setState({});
                            }}
                          />
               </div>
    }

    renderPaymentMethod()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;

        var dispatchTypeConfiguration = state.allowedDispatchTypes.find(d => d.dispatchType == basket.order.dispatchType);
        
        return <div style={{marginTop:'30px'}}>
                    <div style={{fontWeight:'bold', marginBottom:'5px'}}>How would you like to pay</div>
                    <div className="invisible-scrollbar" style={{display:'flex', flexDirection:'row', overflowX:'auto'}}>
                        
                        {this.renderPaymentMethodWidget("Cash", "Pay At Store", 
                                                        dispatchTypeConfiguration.paymentMethods.find(pm => stringUtil.areStringSame(pm, "Cash")) == null,
                                                        stringUtil.areStringSame(basket.order.paymentMethod, "Cash"),
                                                        <BsCashStack size={30}/>)}

                        {this.renderPaymentMethodWidget("Credit", "Credit Card", 
                                                        dispatchTypeConfiguration.paymentMethods.find(pm => stringUtil.areStringSame(pm, "Credit")) == null,
                                                        stringUtil.areStringSame(basket.order.paymentMethod, "Credit"),
                                                        <BsCreditCard2Back size={30}/>)}
                    </div>
            </div>
    }

    renderPaymentMethodWidget(paymentMethod, caption, disabled, isSelected, iconComponent)
    {

        var className = "";
        if(disabled)
            className = "disabledPaymentMethod";
        else if (isSelected)
            className = "selectedPaymentMethod";
        else 
            className="paymentMethod";


        var state = stateManager.getStore().getState();
        var basket = state.basket;

        return <div className={className} style={{marginRight:'10px', border:`var(--menu-item-border)`, padding:'10px'}} 
                    onClick={()=>
                    {
                        if (disabled)
                            return;

                        basket.order.paymentMethod = paymentMethod;
                        this.setState({});
                    }}>
                    <table>
                        <tr>
                            <td style={{textAlign:'center'}}>
                                {iconComponent}
                            </td>
                        </tr>
                        <tr>
                            <td style={{textAlign:'center', whiteSpace:'nowrap'}}>
                                <div className='smallText' style={{textAlign:'center'}}>{caption}</div>
                            </td>
                        </tr>
                    </table>
                </div>;
    }

    renderProceedToPaymentButton()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;

        var caption = `Proceed To Payment - ${formatter.convertToCurrencyFormat(basketUtil.getTotalBasketPrice())}`
        if (stringUtil.areStringSame(basket.paymentMethod, "Cash"))
            caption = `Place Order - ${formatter.convertToCurrencyFormat(basketUtil.getTotalBasketPrice())}`


        return <Button color="primary" 
                    style={{
                            color:`var(--button-addToBasket-font-color)`, 
                            background:`var(--button-addToBasket-background-color)`,
                            borderColor:`var(--button-addToBasket-background-color)`,
                            fontSize:`var(--button-addToBasket-font-size)`,
                            fontWeight:'bold',
                            marginRight:'5px',
                            paddingLeft:'20px',
                            paddingRight:'20px',
                            paddingTop:'10px',
                            paddingBottom:'10px',
                            width:'80%',
                            borderRadius:15
                        }}
                disabled={basket.doRequireEnrichment || stringUtil.isStringNullOrEmpty(basket.order.paymentMethod)}
                onClick={()=>
                    {
                        this.onPaymentButtonClick();
                    }}>{caption}</Button>
    }

    async onPaymentButtonClick()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;

        if (stringUtil.areStringSame(basket.order.paymentMethod, "Cash"))
        {
            this.placeOrder();
            return;
        }

        this.state.showCreditCardPaymentComponent = true;
        this.setState({});
    }

    

    async placeOrder()
    {
        viewUtil.clearErrors();
        var errorMessage = basketUtil.validateBasket();
        if(!stringUtil.isStringNullOrEmpty(errorMessage))
        {
            viewUtil.showErrorAlert(errorMessage);
            return;
        }

        this.state.processingMessage = "Sending Order To Kitchen";
        this.setState({});

        try 
        {
            var response = await basketApiProxy.postBasket();
            previousOrdersUtil.addOrder(response.order);

            var store = stateManager.getStore();
            var state = store.getState();
            state.lastOrderNumber = response.order.number;
            userUtil.sendReceiptToUser(response);

            basketUtil.resetBasket();
            state.user = null;
            
            store.dispatch(currentComponentAction.createAction("confirmation"));
        } 
        catch (error) 
        {
            stateManager.getStore().dispatch(fatalErrorAction.createAction(error));
        }
    }

    renderProcessingMessage()
    {
        if (stringUtil.isStringNullOrEmpty(this.state.processingMessage))
            return null;


        return <BottomSheet open={true} 
                            defaultSnap={({ maxHeight }) => Math.trunc(maxHeight * 0.30)}
                            snapPoints={({ minHeight, maxHeight }) => [Math.trunc(maxHeight * 0.30), Math.trunc(maxHeight * 0.30)]}
                            header="Please Wait">
                    
                    <div style={{marginTop:'20px'}}>
                        <div style={{textAlign:'center'}}>
                            <ScaleLoader
                                        height={50}
                                        width={6}
                                        color={"#808080"}
                                        loading={true}/>
                        </div>
                        <div style={{textAlign:'center'}}>
                            {this.state.processingMessage}
                        </div>
                    </div>

                </BottomSheet> 
    }

    renderPriceWidget()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;

        var components = [];
        components.push(<tr>
                            <td style={{width:'99%'}}>
                                Total Order Price
                            </td>
                            <td style={{whiteSpace:'nowrap', paddingLeft:'20px'}}>
                                {formatter.convertToCurrencyFormat(basketUtil.getTotalOrderPrice())}
                            </td>
                        </tr>);

        components.push(<tr>
                            <td style={{width:'99%'}}>
                                Discount
                            </td>
                            <td style={{whiteSpace:'nowrap', paddingLeft:'20px'}}>
                                {formatter.convertToCurrencyFormat(basketUtil.getTotalDiscounts())}
                            </td>
                        </tr>);

        components.push(<tr>
                            <td style={{width:'99%'}}>
                                Charges
                            </td>
                            <td style={{whiteSpace:'nowrap', paddingLeft:'20px'}}>
                                {formatter.convertToCurrencyFormat(basketUtil.getTotalCharges())}
                            </td>
                        </tr>);

        
        if (!localizationUtils.isVatInclusive() && localizationUtils.isVatApplicable())
        {
            components.push(<tr>
                                <td style={{width:'99%'}}>
                                    {localizationUtils.getVatCaption()}
                                </td>
                                <td style={{whiteSpace:'nowrap', paddingLeft:'20px'}}>
                                    {formatter.convertToCurrencyFormat(basketUtil.getTotalVat())}
                                </td>
                            </tr>);
        }
        

        components.push(<tr>
                            <td style={{width:'99%', fontWeight:'bold'}}>
                                Total Sale Price
                            </td>
                            <td style={{whiteSpace:'nowrap', paddingLeft:'20px', fontWeight:'bold'}}>
                                {formatter.convertToCurrencyFormat(basketUtil.getTotalBasketPrice())}
                            </td>
                        </tr>);

        return <div style={{marginTop:'30px'}}>
                    <table style={{width:'100%'}}>
                        {components}
                    </table>
               </div>

        
    }

    renderKitchenNodesWidget()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;
        return <div style={{marginTop:'30px'}}>
                <div style={{fontWeight:'bold'}}>Kitchen Notes</div>
                    <Input
                            type="text" placeholder="Please enter cooking instructions" 
                            value={basket.order.instructions}
                            onChange={(event)=>
                                {
                                    basket.order.instructions = stringUtil.trimString(event.target.value);
                                    this.setState({});
                                }}
                    />
               </div>
    }

    renderCreditCardPaymentComponent()
    {
        if (!this.state.showCreditCardPaymentComponent)
            return;

        return <PaymentComponent amount={basketUtil.getTotalBasketPrice()} onDismiss={()=>
                                    {
                                        this.state.showCreditCardPaymentComponent = false;
                                        this.setState({});
                                    }}
                                 onCompletion={()=>
                                {
                                    this.state.showCreditCardPaymentComponent = false;
                                    this.setState({});
                                    this.placeOrder()
                                }}/>
    }

    changeQuantity(saleItem, changeBy)
    {
        this.addRemoveQuantity(saleItem, changeBy);
        var state = stateManager.getStore().getState();
        var basket = state.basket;
        basket.order.saleItems = basket.order.saleItems.filter(s => s.quantity > 0);
        basketUtil.markBasketForEnrichment();
        this.state.haltFurtherEnrichmentRequests = false;
        this.setState({});
    }

    addRemoveQuantity(saleItem, changeBy)
    {
        saleItem.quantity = saleItem.quantity + changeBy;
        saleItem.saleItems.forEach(subItem =>
            {
                this.addRemoveQuantity(subItem, changeBy);
            });
    }

    enrichBasket()
    {
        var state = stateManager.getStore().getState();
        var basket = state.basket;

        if (!basket.doRequireEnrichment || this.state.haltFurtherEnrichmentRequests)
            return null;

        this.state.processingMessage = "Enriching your basket";
            
        var originalVoucherCode = basket.voucherCode;
        basketApiProxy.enrichBasket()
        .then(messages =>
            {
                basket.doRequireEnrichment = false;
                var errorMessage = messages.find(m => stringUtil.areStringSame(m.type, "error"));

                viewUtil.clearErrors();
                if (errorMessage != null)
                {
                    basket.voucherCode = originalVoucherCode;
                    basket.doRequireEnrichment = true;
                    this.state.haltFurtherEnrichmentRequests = true;
                    viewUtil.showErrorAlert(errorMessage.message)
                }

                this.state.processingMessage = null;
                this.setState({});
            }, error =>
            {
                stateManager.getStore().dispatch(fatalErrorAction.createAction(error));
            });

        }
}

export default Basket;